/* ==========================================================================
   Harry Taylor Golf — theme behaviour
   Progressive enhancement only: every interaction has a no-JS fallback
   (the bag button is a real link to /cart, forms post normally).
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    return (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  };

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-htg-menu-toggle]');
    var nav = document.getElementById('HtgMobileNav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
    });
  }

  /* ---------- Bag dropdown ---------- */
  function initBag() {
    var wrap = document.querySelector('[data-htg-bag]');
    if (!wrap) return;

    var toggle = wrap.querySelector('[data-htg-bag-toggle]');
    var panel = wrap.querySelector('[data-htg-bag-panel]');
    if (!toggle || !panel) return; // cart_type: page — button stays a plain link

    var closeTimer;

    function open() {
      clearTimeout(closeTimer);
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    // Click opens the panel instead of following the /cart link
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      panel.hidden ? open() : close();
    });

    // Hover intent, matching the design
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(close, 220);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        close();
        toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target) && !panel.hidden) close();
    });
  }

  /* ---------- Cart refresh ---------- */
  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-live', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function () { window.location.reload(); });
  }

  function initCartForms() {
    // Quantity steppers on the bag page
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-htg-qty]');
      if (!btn) return;
      var input = document.getElementById(btn.getAttribute('aria-controls'));
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-htg-qty'), 10);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      input.value = next;
      if (input.form) input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
    });
  }

  /* ---------- Add to bag (AJAX with hard fallback) ---------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-htg-add]');
      if (!form) return;
      if (!window.fetch) return; // let it post normally

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = form.getAttribute('data-adding-label') || 'Adding…';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          // Fall back to a normal form post so the customer is never stuck
          form.removeAttribute('data-htg-add');
          form.submit();
        })
        .finally(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.textContent = original;
          }
        });
    });
  }

  /* ---------- Category strip ----------
     The bar has two states, per the design: the category row, or ONE category's
     product list swapped into the same bar. Never a dropdown. Back button,
     click-outside and Escape all return to the row. Without JS the tiles stay
     plain links to their collections. */
  function initCategoryStrip() {
    var strip = document.querySelector('[data-htg-strip]');
    if (!strip) return;

    var nav = strip.querySelector('[data-htg-strip-nav]');
    var panels = strip.querySelectorAll('[data-htg-strip-panel]');
    var overlay = document.querySelector('[data-htg-strip-overlay]');
    if (!nav || !panels.length) return;

    var openKey = null;

    function close() {
      openKey = null;
      nav.hidden = false;
      for (var i = 0; i < panels.length; i++) panels[i].hidden = true;
      if (overlay) overlay.hidden = true;
      var tiles = nav.querySelectorAll('[data-htg-strip-open]');
      for (var j = 0; j < tiles.length; j++) tiles[j].setAttribute('aria-expanded', 'false');
    }

    function open(key) {
      openKey = key;
      nav.hidden = true;                       // swap in place — same bar, no dropdown
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-htg-strip-panel') !== key;
      }
      if (overlay) overlay.hidden = false;
      var panel = strip.querySelector('[data-htg-strip-panel="' + key + '"]');
      var back = panel && panel.querySelector('[data-htg-strip-back]');
      if (back) back.focus();
    }

    nav.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-htg-strip-open]');
      if (!tile) return;
      e.preventDefault();                      // the href is the no-JS fallback
      open(tile.getAttribute('data-htg-strip-open'));
    });

    strip.addEventListener('click', function (e) {
      if (e.target.closest('[data-htg-strip-back]')) {
        e.preventDefault();
        close();
      }
    });

    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openKey !== null) close();
    });

    close();
  }

  /* ---------- Category tiles ----------
     A snap-scrolling row of category tiles over ONE shared panel. Clicking a
     tile opens that category's panel below the whole row and marks the tile
     open (red border, flipped chevron). Clicking the open tile again, or
     Escape, closes it. Only one open at a time. No overlay — the design
     doesn't have one here. Without JS the tiles stay plain category links. */
  function initCategoryTiles() {
    var root = document.querySelector('[data-htg-tiles]');
    if (!root) return;

    var tiles = root.querySelectorAll('[data-htg-tiles-open]');
    var panels = root.querySelectorAll('[data-htg-tiles-panel]');
    if (!tiles.length || !panels.length) return;

    var openKey = null;

    function close() {
      openKey = null;
      for (var i = 0; i < panels.length; i++) panels[i].hidden = true;
      for (var j = 0; j < tiles.length; j++) {
        tiles[j].setAttribute('aria-expanded', 'false');
        tiles[j].classList.remove('is-open');
      }
    }

    function open(key) {
      close();
      openKey = key;
      for (var i = 0; i < panels.length; i++) {
        panels[i].hidden = panels[i].getAttribute('data-htg-tiles-panel') !== key;
      }
      for (var j = 0; j < tiles.length; j++) {
        var isOpen = tiles[j].getAttribute('data-htg-tiles-open') === key;
        tiles[j].setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        tiles[j].classList.toggle('is-open', isOpen);
      }
    }

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-htg-tiles-open]');
      if (!tile) return;
      e.preventDefault();                      // the href is the no-JS fallback
      var key = tile.getAttribute('data-htg-tiles-open');
      if (key === openKey) {
        close();                               // clicking the open tile closes it
      } else {
        open(key);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openKey !== null) close();
    });

    close();
  }

  /* ---------- Shipping protection ----------
     Auto-adds a real protection product to the bag once there's something else
     in it. Unticking removes it AND remembers the refusal for the session, so it
     never re-adds itself behind the customer's back. Liquid renders the current
     state, so after each change we reload and the markup is authoritative —
     that's what keeps this from looping. */
  var PROTECTION_DECLINED = 'htg:protection-declined';

  function initShippingProtection() {
    var el = document.querySelector('[data-htg-protection]');
    if (!el) return;

    var toggle = el.querySelector('[data-htg-protection-toggle]');
    if (!toggle) return;

    var variantId = el.getAttribute('data-variant-id');
    var lineKey = el.getAttribute('data-line-key');
    var inCart = el.getAttribute('data-in-cart') === 'true';
    var autoAdd = el.getAttribute('data-auto-add') === 'true';
    var otherItems = parseInt(el.getAttribute('data-other-items'), 10) || 0;

    var declined = false;
    try { declined = sessionStorage.getItem(PROTECTION_DECLINED) === '1'; } catch (e) {}

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function busy(state) {
      toggle.disabled = state;
      el.setAttribute('aria-busy', String(state));
    }

    function add() {
      busy(true);
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.reload();
      }).catch(function () { busy(false); toggle.checked = false; });
    }

    function remove() {
      busy(true);
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) throw new Error('remove failed');
        window.location.reload();
      }).catch(function () { busy(false); toggle.checked = true; });
    }

    // Auto-add: only when it's wanted, absent, not refused, and the bag has
    // something else in it. Reload makes inCart true, so this can't run twice.
    if (autoAdd && !inCart && !declined && otherItems > 0) {
      add();
      return;
    }

    toggle.addEventListener('change', function () {
      if (toggle.checked) {
        try { sessionStorage.removeItem(PROTECTION_DECLINED); } catch (e) {}
        add();
      } else {
        try { sessionStorage.setItem(PROTECTION_DECLINED, '1'); } catch (e) {}
        remove();
      }
    });
  }

  /* ---------- HT University membership ----------
     Same shape as shipping protection: Liquid renders the truth, we mutate the
     cart and reload. The difference that matters is `selling_plan` — the
     membership is a SUBSCRIPTION. Added without a plan it bills $120 on the
     spot for something sold as a free year, so a missing data-selling-plan
     means we do nothing whatsoever. There is no plan-less fallback. */
  var HTU_DECLINED = 'htg:htu-declined';

  function initHtuMembership() {
    var el = document.querySelector('[data-htg-htu]');
    if (!el) return;

    var toggle = el.querySelector('[data-htg-htu-toggle]');
    if (!toggle) return;

    var variantId = el.getAttribute('data-variant-id');
    var sellingPlan = el.getAttribute('data-selling-plan');
    var lineKey = el.getAttribute('data-line-key');
    var inCart = el.getAttribute('data-in-cart') === 'true';
    var autoAdd = el.getAttribute('data-auto-add') === 'true';
    var qualifies = el.getAttribute('data-qualifies') === 'true';

    // The hard gate. No selling plan -> no subscription -> no add, ever.
    if (!sellingPlan || !variantId) return;

    var declined = false;
    try { declined = sessionStorage.getItem(HTU_DECLINED) === '1'; } catch (e) {}

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function busy(state) {
      toggle.disabled = state;
      el.setAttribute('aria-busy', String(state));
    }

    function add() {
      if (!sellingPlan) return; // belt and braces — never add plan-less
      busy(true);
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1, selling_plan: Number(sellingPlan) }]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.reload();
      }).catch(function () { busy(false); toggle.checked = false; });
    }

    function remove() {
      busy(true);
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) throw new Error('remove failed');
        window.location.reload();
      }).catch(function () { busy(false); toggle.checked = true; });
    }

    // Auto-add: wanted, absent, not refused, and the bag actually earns it.
    // The reload makes inCart true, so this cannot run a second time.
    if (autoAdd && !inCart && !declined && qualifies) {
      add();
      return;
    }

    toggle.addEventListener('change', function () {
      if (toggle.checked) {
        try { sessionStorage.removeItem(HTU_DECLINED); } catch (e) {}
        add();
      } else {
        try { sessionStorage.setItem(HTU_DECLINED, '1'); } catch (e) {}
        remove();
      }
    });
  }

  /* ---------- Accordion-free FAQ uses <details>; nothing to do ---------- */

  function init() {
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };
    initMenu();
    initBag();
    initCartForms();
    initAddToCart();
    initShippingProtection();
    initHtuMembership();
    initCategoryStrip();
    initCategoryTiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
